import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { movieBookingApi } from '../../services/movieBookingApi';
import './MovieBooking.css';

const BookingStatus = () => {
  const { bookingId } = useParams();
  const [status, setStatus] = useState(null);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let timer;
    const pollStatus = async () => {
      try {
        const response = await movieBookingApi.getBooking(bookingId);
        setStatus(response.data);
      } catch (error) {
        setStatus(null);
      } finally {
        setAttempt((prev) => prev + 1);
      }
    };

    pollStatus();
    timer = setInterval(pollStatus, 2000);
    return () => clearInterval(timer);
  }, [bookingId]);

  return (
    <div className="movie-booking-page">
      <div className="movie-booking-header">
        <div>
          <h1 className="movie-booking-title">Booking Status</h1>
          <p className="movie-booking-note">Booking ID: {bookingId}</p>
        </div>
        <Link to="/movies" className="movie-booking-button secondary">Back to Movies</Link>
      </div>

      {!status && <p>Checking booking status... (attempt {attempt})</p>}
      {status && (
        <div className="movie-booking-card">
          <h3>Status: {status.status}</h3>
          <p className="movie-booking-note">Show: {status.showId}</p>
          <p className="movie-booking-note">Seats: captured in booking flow</p>
          <p className="movie-booking-note">Total Paid: {status.finalTotal}</p>
        </div>
      )}
    </div>
  );
};

export default BookingStatus;
